import React, { useState, useCallback, useEffect, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import DropCard from './DropCard'

// swiper
import { windowSize } from '../../../utils/func'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

const DropsWapper = styled.div`
  margin-top: 64px;
  padding: 40px 0px;
  position: relative;
  &:before{
    content: '';
    opacity: ${({ theme }) => theme.darkMode ? '0.12' : 1};
    background: ${({ theme }) => theme.darkMode ? 'radial-gradient(135.69% 135.92% at 51.27% 41.22%, #FF7EB5 0%, #E486E0 17.98%, #D18CFF 32.8%, #00B7FF 52.4%, #A9F4B1 72.98%, #FFDB63 100%)' : '#ffffff'};
    top:0;
　　 left:0;
 　　bottom:0;
 　　right:0;
 　　position:absolute;
  }
`

const DropsContent = styled.div`
  max-width: 1440px;
  margin: auto;
  position: relative;
  box-sizing: border-box;
  padding: 0px 25px;
`

const NextRightIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  right: 0px;
  top: 300px;
  cursor: pointer;
`
const PrevLeftIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  left: 0px;
  top: 300px;
  cursor: pointer;
`

const Title = styled.div`
  
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${({ theme }) => theme.bsText32};
`

const SwiperWrapper = styled.div`
  position: relative;
  display: flex;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  justify-content: flex-start;
  grid-template-columns: repeat(auto-fill, 272px);
  flex-wrap: nowrap;
  overflow: auto;
  margin-top: 20px;
  max-width: 100%;
  .swiper-pagination {
    display: none;
  }
  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.9);
  }
  .swiper-pagination-bullet-active {
    background: #fffdfa;
  }
`

export default function BakeryDrops() {
  const theme = useContext(ThemeContext)

  const dropsList = [
    {
      image: '/images/drops/drops-piazze.jpg',
      title: 'Piazze Italiane',
      urlName: '/drops/piazze'
    },
    {
      image: '/images/drops/drops-lnkciar.jpg',
      title: 'Lnkciar',
      urlName: '/drops/lnkciar'
    },
    {
      image: '/images/drops/drops-swog.jpg',
      title: 'SWOG',
      urlName: '/drops/swog'
    },
    {
      image: '/images/drops/drops-halloween.jpeg',
      title: 'Halloween NFT Event',
      urlName: '/drops/halloween'
    },
    {
      image: '/images/drops/drops-binamon.jpeg',
      title: 'Genesis Binamons',
      urlName: '/drops/binamons'
    },
    {
      image: '/images/drops/drop-asap.png',
      title: 'Bakery anniversary',
      urlName: '/drops/asap'
    },
    {
      image: '/images/drops/drops_sergi.jpg',
      title: 'Bakery Glass',
      urlName: '/drops/sergi-stamp'
    },
    {
      image: '/images/drops/drops_wuwasha.jpg',
      title: 'ALCHEMY TOYS',
      urlName: '/drops/muwasha'
    },
    {
      image: '/images/drops/cerb.jpg',
      title: 'SWF KlnG',
      urlName: '/drops/cerb'
    },
    {
      image: '/images/drops/irene-cerezo.jpg',
      title: 'BattlePets Donuts',
      urlName: '/drops/irene-cerezo'
    },
    {
      image: '/images/drops/drops_abduction-collection1.png',
      title: 'Abduction Collection',
      urlName: '/drops/abduction-collection'
    }
  ]

  // swiper
  const upToSmall = 500
  const upToMedium = 960
  const upMoreMedium = 1300
  const upToExtraLarge = 1440
  const upToLessLarge = 1520
  const upToMoreLarge = 1600
  const upToLarge = 1750
  const emptySwiper: any = null
  const [swiper, setSwiper] = useState(emptySwiper)
  const [width, setWidth] = useState(windowSize().w)
  const params = {
    loop: true,
    slidesPerView: 4.2,
    spaceBetween: 16,
    pagination: {
      clickable: true,
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    onSwiper: setSwiper
  }
  useEffect(() => {
    if (swiper) {
      if(width <= upToSmall){
        swiper.params.slidesPerView = 1.2
        swiper.params.spaceBetween = 16
      }else if(width <= upToMedium){
        swiper.params.slidesPerView = 2.2
        swiper.params.spaceBetween = 16
      }else if(width <= upMoreMedium){
        swiper.params.slidesPerView = 2.6
        swiper.params.spaceBetween = 16
      }else if(width <= upToExtraLarge){
        swiper.params.slidesPerView = 3.2
        swiper.params.spaceBetween = 16
      }else if(width <= upToLessLarge){
        swiper.params.slidesPerView = 3.3
        swiper.params.spaceBetween = 16
      }else if(width <= upToMoreLarge){
        swiper.params.slidesPerView = 3.5
        swiper.params.spaceBetween = 16
      }else if(width <= upToLarge){
        swiper.params.slidesPerView = 4
        swiper.params.spaceBetween = 16
      }else{
        swiper.params.slidesPerView = 4.2
        swiper.params.spaceBetween = 16
      }
      swiper.autoplay.stop()
    }
  }, [width, swiper])

  const handleResize = useCallback(() => {
    const size = windowSize()
    setWidth(size.w)
  }, [width])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  const slideNext = useCallback(() => {
    swiper.slideNext()
  }, [swiper])

  const slidePrev = useCallback(() => {
    swiper.slidePrev()
  }, [swiper])

  return (
    <DropsWapper>
      <DropsContent>
        <Title>
          Exclusive BakerySwap drops
        </Title>
        <SwiperWrapper>
          <Swiper {...params}>
            {
              dropsList.map((d, index) => {
                return(
                  <SwiperSlide key={index}>
                    <DropCard drop={d}></DropCard>
                  </SwiperSlide>
                )
              })
            }
          </Swiper>
        </SwiperWrapper>
        <NextRightIcon src={theme.darkMode ? "/images/icon/next-dark.png" : "/images/icon/next.png"} onClick={slideNext}/>
        <PrevLeftIcon src={theme.darkMode ? "/images/icon/prev-dark.png" : "/images/icon/prev.png"} onClick={slidePrev}/>
      </DropsContent>
    </DropsWapper>
  )
}